export enum Locale {
  uk = 'uk',
  en = 'en',
  ru = 'ru',
}

export const DEFAULT_LOCALE = Locale.uk;
export const ALL_LOCALES = [Locale.uk, Locale.en];

export function localizeLocale(locale: Locale): string {
  let value: string = '';

  switch (locale) {
    case Locale.uk:
      value = $localize`:Navigation|Ukrainian language title@@navigation-ukrainian-language-title:Ukrainian`;
      break;
    case Locale.en:
      value = $localize`:Navigation|English language title@@navigation-english-language-title:English`;
      break;
    case Locale.ru:
      value = $localize`:Navigation|Russian language title@@navigation-russian-language-title:Russian`;
      break;
  }

  return value;
}
